export default __webpack_public_path__ + "static/media/flower-number-matching.825ee140.png";